export enum ErrorCodes {
  GENERIC = 400,
  BLACKLIST = 406,
  SERVICE = 500,
  OK = 200,
  ALL = 201,
  MISC = 202,
}
